import InvoiceIcon from './InvoiceIcon';

export default InvoiceIcon;
